import { validateEstimatedTiming } from "@shared/common/utils/user-form-validation";
import { Form, FormItemProps, Select, SelectProps } from "antd";

interface IFormItemInputEstimatedTimingProps extends FormItemProps {
  select?: SelectProps;
}

const FormItemInputEstimatedTiming = ({
  select,
  label,
  className,
  ...props
}: IFormItemInputEstimatedTimingProps) => {
  return (
    <Form.Item
      name="estimatedTiming"
      rules={[
        {
          async validator(_rule, value) {
            validateEstimatedTiming(value);
          },
        },
      ]}
      label={label}
      {...props}
      className={className}
    >
      <Select
        placeholder="도입 예상 시기를 선택해 주세요."
        options={[
          { value: "즉시", label: "즉시" },
          { value: "2~3개월 내", label: "2~3개월 내" },
          { value: "6개월 내", label: "6개월 내" },
          { value: "계획 없음", label: "계획 없음" },
        ]}
        {...select}
        className={select?.className}
      />
    </Form.Item>
  );
};

export default FormItemInputEstimatedTiming;
